module.exports = __webpack_public_path__ + "img/base_fan.846a84ff.svg";